
// export const Select = ({ label, name, value = "None", options, onChange, disabled, required, isReport, ...rest }) => {

//     if (isReport) {
//       return (
//           <p>{label}{required && "*"}: {value}</p>
//       );
//     }


//     return (
//       <div className="form-group">
//         <label>{label}{required && "*"}</label>
//         <select name={name} value={value} onChange={onChange} disabled={disabled} {...rest} required>
//           <option value="None">Select an option</option>
//           {options.map((option, index) => (
//             <option key={index} value={option.value} selected={value === option.value}>
//               {option.display_value}
//             </option>
//           ))}
//         </select>
//       </div>
//     );
//   };
  


import React from "react";
import { Tooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import "react-tooltip/dist/react-tooltip.css";
import { useTooltips } from "../../hooks/toolTips"; // adjust path as needed


const getTooltip = (tooltips, label, name) => {
  if (!Array.isArray(tooltips)) {
    console.warn("❌ Tooltips is not an array:", tooltips);
    return "";
  }

  const match = tooltips.find(
    (t) =>
      (label && t.Label?.toLowerCase().trim() === label.toLowerCase().trim()) ||
      (name && t.Name?.toLowerCase().trim() === name.toLowerCase().trim())
  );

  if (!match) {
    console.log(`🔍 No tooltip match found for label="${label}" name="${name}"`);
    return "";
  }

  const tooltipText = match.Tooltip?.trim();
  console.log(`🧩 Found tooltip for "${label || name}": "${tooltipText}"`);

  if (!tooltipText || tooltipText.toLowerCase() === "123" || tooltipText.length < 7) {
    console.log("⚠️ Tooltip skipped (too short or invalid):", tooltipText);
    return "";
  }

  return tooltipText;
};

export const Select = ({
  label,
  name,
  value = "None",
  options,
  onChange,
  disabled,
  required,
  isReport,
  tooltip,
  ...rest
}) => {
  const tooltips = useTooltips();
  const resolvedTooltip = (tooltip || getTooltip(tooltips, label?.replace(/:$/, ""), name))?.replace(/\n/g, "<br/>");

  if (isReport) {
    return (
      <p>
        {label}
        {required && "*"}: {value}
      </p>
    );
  }

  return (
    <div className="form-group">
      <label
        htmlFor={name}
        style={{ display: "flex", alignItems: "center", gap: "6px" }}
      >
        {label}
        {required && "*"}
        {resolvedTooltip && (
          <>
            <span
              data-tooltip-id={`tooltip-${name}`}
              style={{ cursor: "pointer" }}
            >
              <FaInfoCircle size={14} color="#07b1b0" />
            </span>
            <Tooltip
              id={`tooltip-${name}`}
              place="right"
              className="custom-tooltip clickable-tooltip"
              openOnClick={true}
              clickable={true}
              globalCloseEvents={{ clickOutsideAnchor: true }}
            >
              <div className="tooltip-text" dangerouslySetInnerHTML={{ __html: resolvedTooltip }} />
            </Tooltip>
          </>
        )}
      </label>
      <select
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        {...rest}
      >
        <option value="None">Select an option</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.display_value}
          </option>
        ))}
      </select>
    </div>
  );
};
